// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__E1V_Q","content":"LoadingAlert_content__1sKdS"};